import { ManagersTransactionCountFilterValues } from '../../types/banks/ManagersTransactionCountFilterValues';
import { constants } from '../constants';

export const defaultFilterValues = {
    currency: constants.allListItem,
    collateralType: constants.allListItem,
    year: undefined,
} as ManagersTransactionCountFilterValues;
